export default __webpack_public_path__ + "/dist/images/default_image.540ea054960948f941fa5329df5d8dc3.jpg";